import { render, staticRenderFns } from "./DormantPage.vue?vue&type=template&id=22ea0e8c"
import script from "./DormantPage.vue?vue&type=script&lang=js"
export * from "./DormantPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports